import React from "react";
import { ArrowUpRight, MapPinned, MessageCircle, CheckCircle2 } from "lucide-react";
import { waLink } from "../lib/site";

const LAND_IMG =
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=2000&q=80";

const bullets = [
  "Avaliação profissional do loteamento",
  "Análise documental e regularização",
  "Negociação segura e transparente",
  "Pagamento estruturado com respaldo jurídico",
];

export default function LoteamentoCTA() {
  const ctaMsg =
    "Olá ASHIR GROUP, tenho um loteamento aprovado que gostaria de vender. Podem me passar mais informações sobre o processo?";

  return (
    <section
      id="loteamento"
      data-testid="loteamento-section"
      className="relative overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={LAND_IMG}
          alt="Loteamento aprovado — venda estratégica"
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(105deg, rgba(5,7,13,0.96) 0%, rgba(5,7,13,0.88) 50%, rgba(5,7,13,0.55) 100%)",
          }}
        />
        <div
          className="absolute -bottom-20 -right-20 w-[700px] h-[700px] rounded-full opacity-25 pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(212,175,55,0.5) 0%, transparent 65%)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-3 mb-8 pl-4 pr-5 py-2 border border-[#D4AF37]/60 bg-[#D4AF37]/[0.08] backdrop-blur-sm">
              <MapPinned size={14} strokeWidth={1.5} className="text-[#D4AF37]" />
              <span className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-medium">
                Oportunidade Exclusiva
              </span>
            </div>

            <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-6xl xl:text-[4.2rem] font-light leading-[1.02] tracking-[-0.02em]">
              Quer vender seu{" "}
              <span className="text-[#D4AF37] italic">loteamento aprovado?</span>
              <br className="hidden md:block" />
              A ASHIR GROUP é a solução.
            </h2>

            <p className="mt-8 text-[#D6DBE2] text-base md:text-lg lg:text-xl font-light leading-relaxed max-w-2xl">
              Transformamos loteamentos aprovados em <span className="text-white">liquidez imediata</span>.
              Estruturação profissional, pagamento seguro e negociação com o
              padrão institucional que o Vale do Paraíba e São Paulo exigem.
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
              {bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`loteamento-bullet-${i}`}
                  className="flex items-start gap-3 text-[#D6DBE2] font-light"
                >
                  <CheckCircle2
                    size={18}
                    strokeWidth={1.4}
                    className="text-[#D4AF37] mt-0.5 shrink-0"
                  />
                  <span className="text-sm md:text-base">{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <a
                href={waLink(ctaMsg)}
                target="_blank"
                rel="noreferrer"
                data-testid="loteamento-cta-whatsapp"
                className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-[#05070D] px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium hover:bg-[#F0CC59] transition-all duration-300"
              >
                <MessageCircle size={17} strokeWidth={1.6} />
                Entrar em contato pelo WhatsApp
                <ArrowUpRight
                  size={16}
                  strokeWidth={1.6}
                  className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                />
              </a>
            </div>
          </div>

          {/* Right visual pillar */}
          <div className="lg:col-span-4 hidden lg:block">
            <div className="border border-[#D4AF37]/25 p-8 bg-[#05070D]/50 backdrop-blur-sm">
              <div className="overline mb-6">Como funciona</div>
              <ol className="space-y-6">
                {[
                  "Envio dos documentos do loteamento",
                  "Avaliação técnica em até 72h",
                  "Proposta formal com respaldo jurídico",
                  "Pagamento e transferência estruturados",
                ].map((step, i) => (
                  <li
                    key={i}
                    data-testid={`loteamento-step-${i}`}
                    className="flex gap-4 items-start"
                  >
                    <span className="font-serif-ag text-[#D4AF37] text-3xl font-light leading-none w-8 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-[#D6DBE2] text-sm font-light leading-snug pt-1">
                      {step}
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
